/**
 * @memberof module:compressed-json.constants
 * @namespace Prefixes
 */
'use strict';
/** @lends module:compressed-json.constants.Prefixes */

var Prefixes = {
  POINTER_PREFIX: 'p:',
  ESCAPED_PREFIX: 'e:'
};

export default Prefixes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9jb25zdGFudHMvUHJlZml4ZXMuanMiXSwibmFtZXMiOlsiUHJlZml4ZXMiLCJQT0lOVEVSX1BSRUZJWCIsIkVTQ0FQRURfUFJFRklYIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7QUFJQTtBQUVBOztBQUNBLElBQU1BLFFBQVEsR0FBRztBQUNmQyxFQUFBQSxjQUFjLEVBQUUsSUFERDtBQUVmQyxFQUFBQSxjQUFjLEVBQUM7QUFGQSxDQUFqQjtBQUtBQyxNQUFNLENBQUNDLE9BQVAsR0FBaUJKLFFBQWpCIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBAbWVtYmVyb2YgbW9kdWxlOmNvbXByZXNzZWQtanNvbi5jb25zdGFudHNcbiAqIEBuYW1lc3BhY2UgUHJlZml4ZXNcbiAqL1xuJ3VzZSBzdHJpY3QnXG5cbi8qKiBAbGVuZHMgbW9kdWxlOmNvbXByZXNzZWQtanNvbi5jb25zdGFudHMuUHJlZml4ZXMgKi9cbmNvbnN0IFByZWZpeGVzID0ge1xuICBQT0lOVEVSX1BSRUZJWDogJ3A6JyxcbiAgRVNDQVBFRF9QUkVGSVg6J2U6Jyxcbn1cblxubW9kdWxlLmV4cG9ydHMgPSBQcmVmaXhlc1xuIl19